import { Avatar, Flex, Space } from 'antd';
import { ChevronDownIcon, PanelLeftCloseIcon, User } from 'lucide-react';
import React, { useState } from 'react';
import useUser from '@/redux/hooks/useUser';
import AppDropdown from '../AppDropdown';
import LogoutModal from '../AppModal/LogoutModal';
import { LogoutOutlined } from '@ant-design/icons';
import './index.scss';

function Header({ collapsed, setCollapsed }) {
  const {
    user: { fullname },
  } = useUser();
  const [openModal, setOpenModal] = useState(false);

  return (
    <Space className="items-center justify-between w-full h-full">
      <div
        onClick={() => {
          setCollapsed((prev) => !prev);
        }}
        collapsed={collapsed}
        className="cursor-pointer"
      >
        <PanelLeftCloseIcon className={`trigger ${collapsed ? 'collapsed' : ''}`} size={18} />
      </div>
      <Space className="items-center h-fit justify-between gap-4">
        <p className="font-medium">
          Hello, <span className="font-normal">{fullname}</span>
        </p>
        <AppDropdown
          options={[
            {
              key: '1',
              label: 'Sign out',
              icon: <LogoutOutlined />,
              onClick: () => setOpenModal(true),
              danger: true,
            },
          ]}
          onChange={(item) => item.onClick()}
          placement="bottomLeft"
          overlayStyle={{ minWidth: '150px' }}
        >
          <Flex align="center" gap={6}>
            <Avatar icon={<User />} className="bg-gray-400 mb-1" />
            <ChevronDownIcon size={16} />
          </Flex>
        </AppDropdown>
      </Space>

      <LogoutModal openModal={openModal} setOpenModal={setOpenModal} />
    </Space>
  );
}

export default Header;
